import axios from "axios";
import React, { useCallback, useEffect, useMemo, useState } from "react";

/*BootstrapTable anbd table Related*/
import { Paper } from "@material-ui/core";
import { BootstrapTable } from "react-bootstrap-table";

export default function SelectionsSimple({
  className = "",
  initialData = [],
  initialDataSelection = [],
  title,
  itemKey,
  getUrl,
  getProcess,
  onChanged,
  children,
}) {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  const [data, setData] = useState(initialData);
  const [selected, setSelected] = useState(initialDataSelection);

  /**
   * GET
   */
  const requestData = useCallback(() => {
    const url =
      process.env.REACT_APP_API2_URL +
      (getUrl instanceof Function ? getUrl(userInfo) : getUrl);
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        if (getProcess instanceof Function) {
          setData(getProcess(data));
        } else {
          setData(data);
        }
      });
  }, [getUrl, userInfo, getProcess]);

  /**
   * INSERT
   */
  const select = useCallback(
    (row) => {
      setSelected((selected) => [...selected, row?.[itemKey]]);
    },
    [itemKey]
  );

  /**
   * INSERT ALL
   */
  const selectAll = useCallback(
    (rows) => {
      setSelected(rows.map((item) => item?.[itemKey]));
    },
    [itemKey]
  );

  /**
   * DELETE
   */
  const unselect = useCallback(
    (row) => {
      setSelected((selected) =>
        selected.filter((selectedRow) => selectedRow !== row[itemKey])
      );
    },
    [itemKey]
  );

  /**
   * DELETE ALL
   */
  const unselectAll = useCallback(() => {
    setSelected([]);
  }, []);

  /**
   * On Change
   */
  useEffect(() => {
    if (onChanged instanceof Function) {
      onChanged(selected, data);
    }
  }, [selected, onChanged]);

  /**
   * Initial load
   */
  useEffect(() => {
    if (getUrl) {
      requestData();
    }
  }, [getUrl, requestData]);

  const onSelect = useCallback(
    (row, selected) => (selected ? select(row) : unselect(row)),
    [select, unselect]
  );

  const onSelectAll = useCallback(
    (isSelected, rows) => (isSelected ? selectAll(rows) : unselectAll()),
    [selectAll, unselectAll]
  );

  const selectRowProp = {
    mode: "checkbox",
    selected,
    onSelect,
    onSelectAll,
    clickToSelect: true,
  };

  return (
    <div id="main-div" className={`${className}`}>
      <Paper>
        {title ? <h2>{title}</h2> : <></>}

        <BootstrapTable data={data} selectRow={selectRowProp} hover>
          {children}
        </BootstrapTable>
      </Paper>
    </div>
  );
}
